import { parseTL } from "../components/AmountInput";
import { todayIso } from "./format";
import { isTaseronAvans } from "../components/InvoiceForm";
import { uid } from "./uid";

export const emptyLine = { project_id: "", category: "Hizmet", budget_parent_id: "", budget_item_id: "", quantity: "", unit_price: "", kdv_rate: "", tevkifat_rate: "", notes: "" };
export const emptyForm = {
  vendor: "", direction: "", doc_type: "fatura", invoice_no: "", invoice_date: todayIso(), due_date: todayIso(),
  project_id: "", category: "Hizmet", total_amount: "", notes: "", items: [],
  paid: false, budget_parent_id: "", budget_item_id: "", lines: [{ ...emptyLine, _k: "ilk" }],
};

// hakediş faturası: bütçe kalemi seçiliyse Onaylı, değilse Taslak; diğer faturalar "normal"
export const approvalKey = (i) => { if (!i.claim) return "normal"; return i.budget_item_id ? "onayli" : "taslak"; };
// kategori listesi hangi belge türüne göre süzülsün
export const categoryKind = (form) => { if (!form.direction) return ""; if (form.direction === "income") return "income"; return form.doc_type === "fis" ? "fis" : "expense"; };
// cari seçimi değişince proje: eşleşen proje varsa o; yoksa otomatik gelen proje temizlenir, elle seçilen korunur
export const nextProjectId = (f, proj, autoProject) => { if (proj) return proj.id; return f.project_id && f.project_id === autoProject ? "" : f.project_id; };

const r2 = (n) => Math.round(n * 100) / 100;
const rateStr = (v) => (v != null ? String(v) : "");
export const rateOrNull = (v) => (v === "" || v == null ? null : parseFloat(v));
const low = (s) => (s || "").toLocaleLowerCase("tr");

// benzersiz değerlerden A-Z sıralı seçenek listesi
export const distinctOpts = (list, pick) => [...new Set(list.map(pick).filter(Boolean))].sort((a, b) => a.localeCompare(b, "tr")).map((v) => ({ value: v, label: v }));

// form satırları: net / KDV / tevkifat / brüt
export function formTotals(lines) {
  const ls = lines || [];
  const lineNet = (l) => (parseTL(l.quantity) || 0) * (parseTL(l.unit_price) || 0);
  const lineKdv = (l) => Math.round(lineNet(l) * (parseFloat(l.kdv_rate) || 0)) / 100;
  const netNum = ls.reduce((s, l) => s + lineNet(l), 0);
  const kdvAmt = ls.reduce((s, l) => s + lineKdv(l), 0);
  const tevAmt = ls.reduce((s, l) => s + Math.round(lineKdv(l) * (parseFloat(l.tevkifat_rate) || 0)) / 100, 0);
  return { netNum, kdvAmt, tevAmt, grossAmt: r2(netNum + kdvAmt - tevAmt) };
}

// modal satırları: toplamlar + ilk satırın KDV/tevkifat oranı
export function modalTotals(modalLines) {
  const acc = modalLines.reduce((a, l) => {
    const net = r2((Number(l.quantity) || 0) * (Number(l.unit_price) || 0));
    const kdv = Math.round(net * (parseFloat(l.kdv) || 0)) / 100;
    const tev = Math.round(kdv * (parseFloat(l.tevkifat) || 0)) / 100;
    return { net: a.net + net, kdv: a.kdv + kdv, tev: a.tev + tev };
  }, { net: 0, kdv: 0, tev: 0 });
  const modalNet = r2(acc.net), modalKdvAmt = r2(acc.kdv), modalTevAmt = r2(acc.tev);
  const first = modalLines[0];
  return {
    modalNet, modalKdvAmt, modalTevAmt, modalGross: r2(modalNet + modalKdvAmt - modalTevAmt),
    modalKdvRate: first ? (parseFloat(first.kdv) || 0) : 0, modalTevRate: first ? (parseFloat(first.tevkifat) || 0) : 0,
  };
}

// sütun başlığı filtreleri + "yalnız taslaklar"
export function filterInvoices(invoices, onlyDrafts, hf) {
  let list = onlyDrafts ? invoices.filter((i) => i.claim && !i.budget_item_id) : invoices;
  if (hf.tur.length) list = list.filter((i) => hf.tur.includes(i.direction));
  if (hf.firma.length) list = list.filter((i) => hf.firma.includes(i.vendor));
  if (hf.no.trim()) list = list.filter((i) => low(i.invoice_no).includes(low(hf.no.trim())));
  if (hf.tarihFrom) list = list.filter((i) => (i.invoice_date || "") >= hf.tarihFrom);
  if (hf.tarihTo) list = list.filter((i) => (i.invoice_date || "") <= hf.tarihTo);
  if (hf.odemeFrom) list = list.filter((i) => (i.due_date || "") >= hf.odemeFrom);
  if (hf.odemeTo) list = list.filter((i) => (i.due_date || "") <= hf.odemeTo);
  if (hf.proje.length) list = list.filter((i) => hf.proje.includes(i.project_name || "Genel Gider"));
  if (hf.kategori.length) list = list.filter((i) => hf.kategori.includes(i.category || "—"));
  if (hf.tutarMin !== "") list = list.filter((i) => (i.total_amount || 0) >= parseFloat(hf.tutarMin));
  if (hf.tutarMax !== "") list = list.filter((i) => (i.total_amount || 0) <= parseFloat(hf.tutarMax));
  if (hf.durum.length) list = list.filter((i) => hf.durum.includes(i.paid ? "odendi" : "odenmedi"));
  if (hf.onay.length) list = list.filter((i) => hf.onay.includes(approvalKey(i)));
  return list;
}

const upper = (s) => (s || "").trim().toLocaleUpperCase("tr");
const nameWords = (s) => (s || "").toLocaleUpperCase("tr").replace(/[^A-ZÇĞİÖŞÜ0-9 ]/g, " ").replace(/\b(AŞ|A Ş|LTD|ŞTİ|BANKASI|HAKEDİŞ|ÖDEMELERİ)\b/g, " ").split(/\s+/).filter(Boolean);

// proje adına en çok kelimesi uyan gelir alt kalemi (tüm kelimeler eşleşirse +0.5)
function bestIncomeChild(children, projectName) {
  const pw = nameWords(projectName);
  if (!pw.length) return null;
  let best = null, bestScore = 0;
  children.forEach((b) => {
    const bw = nameWords(b.name);
    const hits = bw.filter((w) => pw.includes(w)).length;
    const score = hits && hits === bw.length ? hits + 0.5 : hits;
    if (score > bestScore) { bestScore = score; best = b; }
  });
  return best && bestScore >= 1 ? best : null;
}

// yöne göre otomatik bütçe kalemi: gelir → PROJE GELİRLERİ altında proje adına uyan kalem; gider → PROJE GİDERLERİ (hakedişte TAŞERON ÖDEMELERİ)
export function resolveIncomeBudget(budgetItems, projects, projectId, direction = "income", isClaim = false) {
  if (!direction) return {};
  const parentName = direction === "income" ? "PROJE GELİRLERİ" : "PROJE GİDERLERİ";
  const parent = budgetItems.find((b) => !b.parent_id && b.status === "Aktif" && upper(b.name) === parentName);
  if (!parent) return {};
  const children = budgetItems.filter((b) => b.parent_id === parent.id && b.status === "Aktif");
  if (direction !== "income") {
    const tas = isClaim ? children.find((b) => upper(b.name) === "TAŞERON ÖDEMELERİ") : null;
    return { budget_parent_id: parent.id, budget_item_id: tas ? tas.id : "" };
  }
  const best = bestIncomeChild(children, projects.find((p) => p.id === projectId)?.name);
  return { budget_parent_id: parent.id, budget_item_id: best ? best.id : "" };
}

const autoBudgetFor = (inv, incomeBudget) => (inv.project_id && !inv.budget_item_id ? incomeBudget(inv.project_id, inv.direction || "expense", !!inv.claim) : {});

// önizleme modalı satırları (kalem yoksa tek satır: açıklama + net tutar)
export function modalLinesFrom(inv, incomeBudget) {
  const items = (inv.items || []).length ? inv.items : [{ description: inv.notes || inv.category || "", unit: "", quantity: 1, unit_price: inv.net_amount ?? inv.total_amount ?? 0, total: inv.net_amount ?? inv.total_amount ?? 0 }];
  const auto = autoBudgetFor(inv, incomeBudget);
  return items.map((it) => ({
    _k: uid(), description: it.description || "", unit: it.unit || "", quantity: it.quantity || 0, unit_price: it.unit_price || 0,
    parent: inv.budget_parent_id || auto.budget_parent_id || "", item: inv.budget_item_id || auto.budget_item_id || "",
    kdv: rateStr(inv.kdv_rate), tevkifat: rateStr(inv.tevkifat_rate),
  }));
}

export const modalBudgetFrom = (inv) => ({ parent: inv.budget_parent_id || "", item: inv.budget_item_id || "", kdv: rateStr(inv.kdv_rate), tevkifat: rateStr(inv.tevkifat_rate), fatura_tarihi: inv.invoice_date || "", odeme_tarihi: inv.due_date || "", fatura_no: inv.invoice_no || "" });

// taslak hakediş faturası → düzenleme formu
export function draftToForm(inv, incomeBudget) {
  const base = {
    project_id: inv.project_id || "", category: inv.category || "Hizmet", budget_parent_id: inv.budget_parent_id || "", budget_item_id: inv.budget_item_id || "",
    kdv_rate: rateStr(inv.kdv_rate), tevkifat_rate: rateStr(inv.tevkifat_rate),
    ...autoBudgetFor(inv, incomeBudget),
  };
  const items = (inv.items || []).filter((it) => (it.quantity || 0) * (it.unit_price || 0) !== 0 || it.description);
  const tlStr = (n) => (n == null ? "" : String(r2(n)).replace(".", ","));
  const lines = items.length
    ? items.map((it) => ({ ...base, _k: uid(), quantity: tlStr(it.quantity || 1), unit_price: tlStr(it.unit_price || 0), notes: it.description || "" }))
    : [{ ...base, _k: uid(), quantity: "1", unit_price: tlStr(inv.net_amount ?? inv.total_amount ?? 0), notes: inv.notes || "" }];
  return {
    ...emptyForm, vendor: inv.vendor, direction: inv.direction || "expense", doc_type: inv.doc_type || "fatura",
    invoice_no: inv.invoice_no || "", invoice_date: inv.invoice_date || todayIso(), due_date: inv.due_date || todayIso(), paid: !!inv.paid, lines,
    notes: items.length ? (inv.notes || "") : "",
  };
}

// taslak düzenleme: tek fatura PUT gövdesi (ilk satırın proje/kategori/bütçe/KDV bilgisi)
export function editPayload(form, lines) {
  const l = lines[0];
  const items = lines.map((x) => {
    const q = parseTL(x.quantity) || 0, up = parseTL(x.unit_price) || 0;
    return { description: x.notes || "", unit: "", quantity: q, unit_price: up, total: r2(q * up) };
  });
  const net = r2(items.reduce((s, it) => s + it.total, 0));
  return {
    vendor: form.vendor, direction: form.direction, doc_type: form.doc_type || "fatura",
    invoice_no: form.invoice_no, invoice_date: form.invoice_date, due_date: form.due_date,
    project_id: l.project_id, category: l.category, budget_parent_id: l.budget_parent_id, budget_item_id: l.budget_item_id,
    paid: !!form.paid, total_amount: net, net_amount: net,
    kdv_rate: parseFloat(l.kdv_rate), tevkifat_rate: rateOrNull(l.tevkifat_rate),
    notes: (form.notes || "").trim() || (lines.length === 1 ? (l.notes || "") : ""), items,
  };
}

// yeni kayıt: çok satırlı bulk POST gövdesi
export function bulkPayload(form, lines) {
  return {
    vendor: form.vendor, direction: form.direction, doc_type: form.doc_type || "fatura",
    invoice_no: form.invoice_no, invoice_date: form.invoice_date, due_date: form.due_date,
    paid: !!form.paid, notes: form.notes || "",
    lines: lines.map((l) => ({
      project_id: l.project_id || null, category: l.category, budget_parent_id: l.budget_parent_id || null, budget_item_id: l.budget_item_id || null,
      quantity: parseTL(l.quantity) || 0, unit_price: parseTL(l.unit_price) || 0,
      kdv_rate: parseFloat(l.kdv_rate), tevkifat_rate: rateOrNull(l.tevkifat_rate), notes: l.notes || "",
      installments: isTaseronAvans(l.category) ? (l.installments || 1) : null,
    })),
  };
}
